import { render, staticRenderFns } from "./ad-best-match-search-table.vue?vue&type=template&id=2be9bace"
import script from "./ad-best-match-search-table.vue?vue&type=script&lang=ts"
export * from "./ad-best-match-search-table.vue?vue&type=script&lang=ts"
import style0 from "./ad-best-match-search-table.vue?vue&type=style&index=0&id=2be9bace&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports